import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faArrowDown } from '@fortawesome/pro-solid-svg-icons/faArrowDown';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { faArrowsAlt } from '@fortawesome/pro-solid-svg-icons/faArrowsAlt';
import { faBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell';
import { faBookSpells } from '@fortawesome/pro-solid-svg-icons/faBookSpells';
import { faBrowser } from '@fortawesome/pro-solid-svg-icons/faBrowser';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faClipboardList } from '@fortawesome/pro-solid-svg-icons/faClipboardList';
import { faClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faCode } from '@fortawesome/pro-solid-svg-icons/faCode';
import { faCog } from '@fortawesome/pro-solid-svg-icons/faCog';
import { faCogs } from '@fortawesome/pro-solid-svg-icons/faCogs';
import { faDesktop } from '@fortawesome/pro-solid-svg-icons/faDesktop';
import { faDirections } from '@fortawesome/pro-solid-svg-icons/faDirections';
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons/faExternalLink';
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash';
import { faFilter } from '@fortawesome/pro-solid-svg-icons/faFilter';
import { faGamepad } from '@fortawesome/pro-solid-svg-icons/faGamepad';
import { faGlobeEurope } from '@fortawesome/pro-solid-svg-icons/faGlobeEurope';
import { faHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faInbox } from '@fortawesome/pro-solid-svg-icons/faInbox';
import { faInfo } from '@fortawesome/pro-solid-svg-icons/faInfo';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faLightbulb } from '@fortawesome/pro-solid-svg-icons/faLightbulb';
import { faMedal } from '@fortawesome/pro-solid-svg-icons/faMedal';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faPenFancy } from '@fortawesome/pro-solid-svg-icons/faPenFancy';
import { faPhone } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faPlug } from '@fortawesome/pro-solid-svg-icons/faPlug';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle';
import { faPodium } from '@fortawesome/pro-solid-svg-icons/faPodium';
import { faPowerOff } from '@fortawesome/pro-solid-svg-icons/faPowerOff';
import { faPrint } from '@fortawesome/pro-solid-svg-icons/faPrint';
import { faPuzzlePiece } from '@fortawesome/pro-solid-svg-icons/faPuzzlePiece';
import { faQuestion } from '@fortawesome/pro-solid-svg-icons/faQuestion';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { faQuoteLeft } from '@fortawesome/pro-solid-svg-icons/faQuoteLeft';
import { faRss } from '@fortawesome/pro-solid-svg-icons/faRss';
import { faSatelliteDish } from '@fortawesome/pro-solid-svg-icons/faSatelliteDish';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faShieldAlt } from '@fortawesome/pro-solid-svg-icons/faShieldAlt';
import { faShoppingCart } from '@fortawesome/pro-solid-svg-icons/faShoppingCart';
import { faSignOutAlt } from '@fortawesome/pro-solid-svg-icons/faSignOutAlt';
import { faSms } from '@fortawesome/pro-solid-svg-icons/faSms';
import { faSort } from '@fortawesome/pro-solid-svg-icons/faSort';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faStarOfLife } from '@fortawesome/pro-solid-svg-icons/faStarOfLife';
import { faTicketAlt } from '@fortawesome/pro-solid-svg-icons/faTicketAlt';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faTruck } from '@fortawesome/pro-solid-svg-icons/faTruck';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUserCircle } from '@fortawesome/pro-solid-svg-icons/faUserCircle';
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faUserSecret } from '@fortawesome/pro-solid-svg-icons/faUserSecret';
import { faClipboardUser } from '@fortawesome/pro-solid-svg-icons';

// "fal" - Usage example: <font-awesome-icon :icon="['fal', 'paperclip']"></font-awesome-icon>
import { faArrowLeft as faArrowLeftLight } from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import { faCheckCircle as faCheckCircleLight } from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import { faPaperclip as faPaperclipLight } from '@fortawesome/pro-light-svg-icons/faPaperclip';
import { faSearch as faSearchLight } from '@fortawesome/pro-light-svg-icons/faSearch';
import { faTimes as faTimesLight } from '@fortawesome/pro-light-svg-icons/faTimes';

import { faClock as faClockRegular } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faEnvelope as faEnvelopeRegular } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faFileAlt as faFileAltRegular } from '@fortawesome/pro-regular-svg-icons/faFileAlt';
import { faTruck as faTruckRegular } from '@fortawesome/pro-regular-svg-icons/faTruck';
import { faTv as faTvRegular } from '@fortawesome/pro-regular-svg-icons/faTv';

import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';

Vue.component('font-awesome-icon', FontAwesomeIcon);

library.add(
    faArrowLeftLight,
    faBars,
    faBrowser,
    faBookSpells,
    faCode,
    faChevronLeft,
    faChevronRight,
    faCog,
    faCogs,
    faCaretDown,
    faDirections,
    faMedal,
    faChevronDown,
    faChevronUp,
    faFilter,
    faLightbulb,
    faUser,
    faUsers,
    faUserSecret,
    faUserCircle,
    faTruck,
    faSatelliteDish,
    faSignOutAlt,
    faStarOfLife,
    faPencil,
    faPlusCircle,
    faPodium,
    faPenFancy,
    faPuzzlePiece,
    faPlug,
    faBell,
    faArrowsAlt,
    faArrowLeft,
    faArrowRight,
    faArrowDown,
    faSpinner,
    faSearch,
    faSearchLight,
    faTimes,
    faTimesCircle,
    faTicketAlt,
    faTrash,
    faCheck,
    faClock,
    faCheckCircle,
    faCheckCircleLight,
    faExclamation,
    faExclamationCircle,
    faExternalLink,
    faInfoCircle,
    faInfo,
    faTimesLight,
    faQuestion,
    faQuestionCircle,
    faQuoteLeft,
    faSms,
    faClipboardList,
    faPaperPlane,
    faEnvelope,
    faEye,
    faEyeSlash,
    faShoppingCart,
    faRss,
    faDesktop,
    faGamepad,
    faStar,
    faCircle,
    faPhone,
    faPowerOff,
    faEnvelope,
    faShieldAlt,
    faTvRegular,
    faEnvelopeRegular,
    faFileAltRegular,
    faTruckRegular,
    faDownload,
    faPrint,
    faPaperclipLight,
    faGlobeEurope,
    faInbox,
    faSort,
    faHeart,
    faFacebookF,
    faInstagram,
    faLinkedinIn,
    faTwitter,
    faClockRegular,
    faClipboardUser,
);
